import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudArrowUp32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCloudArrowUp32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m24.957 15.25-.12 1.044.792.691A4 4 0 0 1 23 24H9a4 4 0 0 1-1.966-7.485l1.171-.662-.172-1.334a4 4 0 0 1 4.594-4.47l.918.144.702-.609a6.5 6.5 0 0 1 10.71 5.666M3 20a6 6 0 0 1 3.05-5.226 6 6 0 0 1 6.888-6.702 8.5 8.5 0 0 1 14.007 7.406A6 6 0 0 1 23 26H8.999a6 6 0 0 1-6-6m9.111-2.197a1 1 0 0 1 0-1.414l3.182-3.182L16 12.5l.707.707 3.182 3.182a1 1 0 0 1-1.414 1.414L17 16.328v4.329a1 1 0 1 1-2 0v-4.329l-1.475 1.475a1 1 0 0 1-1.414 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCloudArrowUp32);
